export default "__VITE_ASSET__Cm_TaHf9__"